export default $axios => ({
  fetch() {
    return $axios.$get('/v2/store-opening-hours')
  },
  getServiceName: () => 'storeOpeningHoursService',
})
